import forEach from 'lodash/forEach'
import trim from 'lodash/trim'
import type { DonorDetails, UrlParamsDonorDetails } from '@/types'

export const emptyDonorDetails: DonorDetails = {
  emailAddress: '',
  firstname: '',
  lastname: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  county: '',
  postcode: '',
  country: '',
}

// As emptyDonorDetails but with lowercase property names
export const emptyQueryObj = Object.fromEntries(
  Object.entries(emptyDonorDetails).map(([key, value]) => [
    key.replace(/([A-Z])/g, '$1').toLowerCase(),
    value,
  ])
) as UrlParamsDonorDetails<DonorDetails>

export const formatUrlQueryDetails = (
  query: UrlParamsDonorDetails<DonorDetails> | {} = {}
): UrlParamsDonorDetails<DonorDetails> => {
  const queryDetails: UrlParamsDonorDetails<DonorDetails> = {
    ...emptyQueryObj,
    ...query,
  }

  forEach(queryDetails, (value, key) => {
    ;(queryDetails as Record<string, string>)[key] = trim(value)
  })

  return queryDetails
}

export const mapQueryToDonorDetails = (
  query: UrlParamsDonorDetails<DonorDetails>
): DonorDetails => {
  const trimmedQueryParams = formatUrlQueryDetails(query)
  const { emailaddress, addressline1, addressline2, emailsignature } =
    trimmedQueryParams

  const result = {
    ...trimmedQueryParams,
    emailAddress: emailaddress || '',
    addressLine1: addressline1 || '',
    addressLine2: addressline2 || '',
    emailSignature: emailsignature || '',
  } as DonorDetails

  if ('emailaddress' in result) {
    delete result.emailaddress
  }

  if ('addressline1' in result) {
    delete result.addressline1
  }

  if ('addressline2' in result) {
    delete result.addressline2
  }

  if ('emailsignature' in result) {
    delete result.emailsignature
  }

  return result
}

export const hasAddress = (urlQuery: any): boolean => {
  return (
    urlQuery.addressLine1 !== '' ||
    urlQuery.addressLine2 !== '' ||
    urlQuery.city !== '' ||
    urlQuery.county !== '' ||
    urlQuery.country !== ''
  )
}
